import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService, UserType} from 'src/app/services/session.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService} from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ConditionsDialogComponent } from '../conditions-dialog/conditions-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  signupForm = false;
  username = '';
  password = '';
  confirmPassword = null;
  signingIn = false;
  emailEmptyError = false;
  passwordEmptyError = false;
  loginFailed = false;
  sessionAvailable = true;

  constructor(
    private router: Router, private sessionService: SessionService, private trustiiService: TrustiiService,
    private route: ActivatedRoute, private dataservice: DataService, private matDialog: MatDialog
  ) {
    document.body.style.backgroundImage = 'url("/assets/img/TrustiiHomePage.png")';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
  }

  ngOnInit() {
    this.route.data
      .subscribe(
        (res) => {
          if (res.data) {
            this.sessionAvailable = true;
            this.sessionService.setToken(res.data.token);
            this.sessionService.setUser(res.data);
            this.sessionService.tokenData.next({session: true});
            this.loadVendor();
          } else {
            this.sessionAvailable = false;
            this.sessionService.setUserType(UserType.Vendor);
          }
        });
  }

  loadRoute(e) {
    if (this.username.length < 1) {
      this.emailEmptyError = true;
    }
    if (this.password.length < 1) {
      this.passwordEmptyError = true;
    }

    if (this.emailEmptyError || this.passwordEmptyError) {
      return;
    }

    if (this.sessionService.getUserType() === null) {
      this.router.navigateByUrl('', {skipLocationChange: false});
      return;
    }

    this.signingIn = true;
    this.trustiiService.login(this.username, this.password).subscribe(
      (res) => {
        this.signingIn = false;
        this.sessionService.setToken(res.data.token);
        this.sessionService.setUser(res.data);
        localStorage.setItem('token', res.data.token);
        this.sessionService.tokenData.next({session: true});
        this.trustiiService.vendorConditionToAccept().subscribe(
          (conditionRes: any) => {
            if (conditionRes.data.length > 0) {
              this.matDialog.open(ConditionsDialogComponent, {
                height: '200px',
                width: '650px',
                data: {
                  datasets: conditionRes.data,
                },
              }).afterClosed();
            }
          },
          (err) => {
            // this.isReady = true;
            // this.elements = [];
          }
        );
        this.loadVendor();
      },
      (err) => {
        if (err.error.error.code && 'reset_password' === err.error.error.code) {
          this.dataservice.setData({resetPassword: true});
          this.sessionService.setUser({
            firstname: err.error.error.user.firstname,
            lastname: err.error.error.user.lastname,
            email: err.error.error.user.email,
          });
          localStorage.setItem('token', err.error.error.user.token);
          this.loadReset();
        }

        this.signingIn = false;
        this.loginFailed = true;
      }
    );
  }

  onUsernameKey(e) {
    this.username = e.target.value;
    if (this.username.length > 0) {
      this.emailEmptyError = false;
    }
  }

  onPasswordKey(e) {
    this.password = e.target.value;
    if (this.password.length > 0) {
      this.passwordEmptyError = false;
    }
  }

  loadEnterprise() {
    if (this.sessionService.getVendor().isUniversity === 'yes') {
      this.router.navigateByUrl('datasets');
      return;
    }
    this.router.navigateByUrl('enterprise/datasets');
  }

  loadVendor() {
    this.router.navigateByUrl('datasets', {skipLocationChange: false});
  }

  loadReset() {
    this.router.navigateByUrl('password/change', {skipLocationChange: false});
  }

  goHome() {
    this.router.navigateByUrl('', {skipLocationChange: false});
  }

  goPasswordReset() {
    this.router.navigateByUrl('/password/reset', {skipLocationChange: false});
  }

  ngOnDestroy() {
    document.body.style.backgroundImage = '';
  }

  loadSignUp() {
    this.router.navigate(
      ['signup'],
      {},
    );
  }
}
